module.exports = __webpack_public_path__ + "static/media/academia_02.fd5a61a9.jpg";